export default {"src":"/_next/static/media/bix.396b5446.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};